"use client";

// GenerateWidgets از Server Component هم رندر می‌شود و آن‌جا dynamic() کد را جدا نمی‌کند؛ بدون این مرز
// client کل فرم‌ساز core (موتور فرم، فیلدها و CSS آن) در چانک مشترک همه‌ی صفحه‌ها می‌آمد.
// بدون loading: fallback در این پروژه DOM را دو برابر می‌کند.
// ssr: false: صفحه زیر dynamic() رندر می‌شود و useId فرم‌ساز روی سرور و کلاینت فرق می‌کند (hydration mismatch و
// پیدا نشدن فیلد خطادار برای فوکوس). فرم بدون JS هم کار نمی‌کند؛ پس فقط فرم سمت کلاینت ساخته می‌شود و بقیه‌ی صفحه SSR است.
import dynamic from "next/dynamic";

const ContactUsForm = dynamic(() => import("./_contactusForm"), { ssr: false });

export default ContactUsForm;
